import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import ChartPeriod from '../ChartPeriod.js';
import {
	CHART_PERIOD_SELECTION_CATEGORY_KEY,
	CHART_PERIOD_SELECTION_COMPONENT_KEY,
} from '../ChartPeriodSelection.meta.js';

export default InjectedStyledComponent(
	ChartPeriod,
	CHART_PERIOD_SELECTION_CATEGORY_KEY,
	CHART_PERIOD_SELECTION_COMPONENT_KEY,
	['activeChartPeriod'],
);
